import { useState, useEffect } from "react";
import { fetchBookedList } from "../../../../services/getBookingList";
import BookingListCard from "./BookingCard/BookingListCard";
import PendingBookingCard from "./pendingBookingCard/PendingBookingCard";
import { Link, useNavigate } from "react-router-dom";

const validStatuses = [
  { number: 0, value: "Inactive" },
  { number: 2, value: "Pending" },
  { number: 3, value: "Approved" },
  { number: 4, value: "Reject" },
  { number: 15, value: "BookingClosed" },
  { number: 6, value: "Cancelled" },
];

const MyBooking = () => {
  const [bookedList, setBookedList] = useState([]);
  const fetchBookings = async () => {
    try {
      const data = await fetchBookedList();
      setBookedList(data);
    } catch (error) {
      console.error("Error fetching booked list:", error.message);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  const navigate = useNavigate();

  const handleNavigate = (name, id) => {
    const formattedName = name.replace(/\s+/g, "-"); // Replace spaces with dashes
    navigate(`/details?table=${encodeURIComponent(formattedName)}&id=${id}`);
  };

  return (
    <>
      {bookedList.map((item) =>
        [0, 2, 4, 15, 6].includes(item?.table_details?.status) ? (
          <div style={{ pointerEvents: "none" }}>
            <PendingBookingCard
              orderId={item?.order_id}
              cardDetails={item?.table_details}
              userDetails={item?.creator_details}
              key={item.id}
              booking={true}
              closed={true}
            />
          </div>
        ) : item?.payment_id === "" ? (
          <div
            onClick={() =>
              handleNavigate(
                item?.table_details?.title,
                item?.table_details?.id
              )
            }
          >
            <div style={{ pointerEvents: "none" }}>
              <BookingListCard
                cardDetails={item?.table_details}
                key={item.id}
                booking={true}
                pending={true}
              />
            </div>
          </div>
        ) : new Date(item?.table_details?.event_date) < new Date() ? (
          <div style={{ pointerEvents: "none" }}>
            <PendingBookingCard
              orderId={item?.order_id}
              cardDetails={item?.table_details}
              userDetails={item?.creator_details}
              key={item.id}
              datePassed={true}
            />
          </div>
        ) : (
          <BookingListCard
            cardDetails={item?.table_details}
            key={item.id}
            booking={true}
          />
        )
      )}
    </>
  );
};

export default MyBooking;
